import { useStaticQuery, graphql } from 'gatsby';
import useLogo from 'gatsby-theme-core/src/hooks/use-logo';

const useEALogo = () => {
  const fallbackLogo = useLogo();
  const { strapi } = useStaticQuery(graphql`
    query EALogoQuery {
      strapi {
        getSite {
          logo {
            name
            url
            width
            height
            imageFile {
              childImageSharp {
                # EA logo is 259, sadly
                gatsbyImageData(layout: FIXED, width: 259, placeholder: BLURRED)
              }
            }
          }
        }
      }
    }
  `);

  return strapi.getSite.logo || fallbackLogo;
};

export default useEALogo;
